import { UserCheck, X } from "lucide-react";
import { useImpersonation } from "@/lib/impersonation-context";

export function ImpersonationBanner() {
  const { isImpersonating, activePersona, exitImpersonation } = useImpersonation();
  if (!isImpersonating || !activePersona) return null;

  const name =
    [activePersona.firstName, activePersona.lastName].filter(Boolean).join(" ") ||
    activePersona.email;

  return (
    <div
      data-component="impersonation-banner"
      data-active-user-id={activePersona.userId}
      className="sticky top-0 z-40 flex items-center gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm"
    >
      <UserCheck className="h-4 w-4 shrink-0 text-amber-600" />
      <span className="flex-1 text-amber-800">
        Viewing as <strong data-field="active-persona-name">{name}</strong>
        <span className="ml-1 font-normal text-amber-600">({activePersona.email})</span>
      </span>
      <button
        type="button"
        data-action="exit-impersonation"
        onClick={() => void exitImpersonation()}
        className="flex items-center gap-1.5 rounded-md border border-amber-400 bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-900 hover:bg-amber-200 transition-colors"
      >
        <X className="h-3 w-3" />
        Exit
      </button>
    </div>
  );
}
